export default "__VITE_ASSET__iSu7EsIQ__"